import styles from './Button.module.css';

const VARIANTS = {
    primary: styles.primary,
    outline: styles.outline,
    'outline-danger': styles.outlineDanger,
    danger: styles.danger,
};

const Button = ({ variant = 'primary', type = 'button', className = '', children, ...props }) => {
    return (
        <button
            type={type}
            className={`${styles.button} ${VARIANTS[variant] || VARIANTS.primary} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
